import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faEllipsis, faInfoCircle, faRecycle } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  reverseTxn
} from "../../../controllers/V1/transactionController";
import { getPage } from "../../../controllers/common";

import {
  list as getUserList,
} from "../../../controllers/V1/customerDue/dueController";
import ExportPopup from './Export';
import {usePermissions} from "../../../controllers/PermissionContext";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BasicTabs() {
  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

 const PERMISSION = usePermissions("transaction");
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(false);
  const targetRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  // const [USER_ID, setUserId] = useState("");
  const [fromDate, setFromDate] = useState(moment().startOf('day').format('YYYY-MM-DD HH:mm'));
  const [toDate, setToDate] = useState(moment().endOf('day').format('YYYY-MM-DD HH:mm'));

  const [ filter, setFilter ] = useState({
    from_date : fromDate,
    to_date : toDate,
    user_id : "",
  })
  const formRef = useRef(null);
  
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);

      const options = {
        type: "",
        condition: {
          ...(filter?.user_id && { 
            $or : [
              {credit_user : filter?.user_id},
              {debit_user : filter?.user_id},
            ]
          }),
          ...(filter?.narration && {narration : filter?.narration}),
          ...((filter?.from_date && filter?.to_date) && {
            createdAt : {$gte : `${filter?.from_date}:00`, $lte : `${filter?.to_date}:00`}
          })
         
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleSearch = async (e) =>{
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      console.log('narration : ', formData.get('narration'));
      setIsLoading(true);
      const options = {
        type : "single",
        condition : { 
          ...(formData.get('searchField') === 'users_email' && {last_name : { $regex: formData.get('searchText'), $options: "i" }}),
          ...(formData.get('searchField') === 'store_name' && {store_name : { $regex: formData.get('searchText'), $options: "i" }}),
          ...(formData.get('searchField') === 'users_mobile' && {users_mobile : parseInt(formData.get('searchText'))}),
          ...(formData.get('searchField') === 'pos_number' && {pos_number : parseInt(formData.get('searchText'))}),
         }
      }
      const res = await getUserList(options);
      if(res?.status === true && formData.get('searchField') && formData.get('searchText')){
        setFilter((pre)=>({
          ...pre,
          ...(formData.get('narration') && {narration : formData.get('narration')}),
          ...(formData.get('searchField') && {searchField : formData.get('searchField') || ""}),
          ...(formData.get('searchText') && {searchField : formData.get('searchText') || ""}),
          ...(formData.get('from_date') && {from_date : moment(formData.get('from_date')).format('YYYY-MM-DD HH:mm:ss')}),
          ...(formData.get('to_date') && {to_date : moment(formData.get('to_date')).format('YYYY-MM-DD HH:mm:ss')}),
          user_id : res?.result?._id || ''
        }))
      } else{
        setFilter((pre)=>({
          ...pre,
          ...(formData.get('narration') && {narration : formData.get('narration')}),
          ...(formData.get('searchField') && {searchField : formData.get('searchField') || ""}),
          ...(formData.get('searchText') && {searchField : formData.get('searchText') || ""}),
          ...(formData.get('from_date') && {from_date : moment(formData.get('from_date')).format('YYYY-MM-DD HH:mm:ss')}),
          ...(formData.get('to_date') && {to_date : moment(formData.get('to_date')).format('YYYY-MM-DD HH:mm:ss')}),
        }))
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      // setIsLoading(false);
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    // if(USER_ID){
      getList();
    // }
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Transaction History";
  }, [currentPage, filter]);

  const handleReverseAmount = async (id) => {
    try {
      const res = await reverseTxn({txn_id : id});
      if(res?.status === true){
        notification.open({
            message: "Success",
            description: `Amount Reverse successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
        });
        getList();
      } else{
        notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
        });
      }
    } catch (error) {
      notification.open({
          message: "Oops!",
          description: `Something when wrong! Please try again.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
      });
    }
  }

  const handleDateChange = async (e) => {
    try {
      const { name, value } = e.target;
      console.log(`[${name}] `, value);
      if(name === 'from_date'){
        setFromDate(moment(value).format('YYYY-MM-DD HH:mm'));
      } else if(name === 'to_date'){
        setToDate(moment(value).format('YYYY-MM-DD HH:mm'));
      }
      console.log(' fromDate : ', fromDate);
    } catch (error) {
      console.log('error : ', error);
    }
  }

  const handleReset = async () => {
    setFromDate(moment().startOf('day').format('YYYY-MM-DD HH:mm'));
    setToDate(moment().endOf('day').format('YYYY-MM-DD HH:mm'));

    setFilter({
      from_date : moment().startOf('day').format('YYYY-MM-DD HH:mm'),
      to_date : moment().endOf('day').format('YYYY-MM-DD HH:mm'),
      user_id : "",
    }); 
    if(formRef.current) formRef.current.reset();
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Transaction History"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <form onSubmit={handleSearch} ref={formRef} >
                <div className="row">
                  <div className="inventory_all_tabs">
                    <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <select name="searchField" id="searchField" className="form-control store_input_field">
                        <option value="">Select Fields</option>
                        <option value={`store_name`}>Store Name</option>                        
                        <option value={`users_mobile`}>Mobile</option>
                        <option value={`users_email`}>Email</option>
                        <option value={`pos_number`}>POS Number</option>
                      </select>
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <input type="text" name="searchText" id="searchText" placeholder="Search" className="form-control store_input_field" />
                    </div>

                    <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12">
                      <select name="narration" id="narration"  className="form-control store_input_field">
                        <option value={""}>Select Narration</option>
                        <option value={`Invoice`}>Invoice</option>
                        <option value={`Collect Amount`}>Collect Amount</option>
                        <option value={`Settled Amount`}>Settled Amount</option>
                        <option value={`Update Due Amount`}>Update Due Amount</option>
                        <option value={`Submitted Amount`}>Submitted Amount</option>
                      </select>
                    </div>
                    
                  </div>
                </div>

                <div className="row">
                  <div className="inventory_all_tabs">
                    
                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <input type="datetime-local" value={fromDate} onChange={handleDateChange} name="from_date" id="from_date" className="form-control store_input_field" />
                    </div>

                    <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <input type="datetime-local" value={toDate} onChange={handleDateChange} name="to_date" id="to_date" className="form-control store_input_field" />
                    </div>

                    <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <button type="submit" disabled={isLoading} className="btn btn-danger" >Search</button>
                    </div>

                    <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <button type="button" onClick={handleReset} disabled={isLoading} className="btn btn-light" >Reset</button>
                    </div>
                    {(PERMISSION?.export === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                      <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                        <button type="button" className="btn btn-light" onClick={handleExportDrawer}>Export</button>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>User's Details</th>                              
                              <th>Before Amount</th>
                              <th>Other Expanse</th>
                              <th>Amount</th>
                              <th>After Amount</th>
                              <th>Narration</th>
                              <th>Record Type</th>
                              <th>From</th>
                              <th>Sales Agent</th>
                              <th>Created At</th>
                              {(PERMISSION?.reverse === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                <th>Action</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{SKIP + index + 1}</td>
                                    <td className="admin_user_list_date">
                                      {items?.record_type === 'Credit' ? (
                                        <>
                                          {items?.credit_user?.store_name && (
                                            <span>Store: {items?.credit_user?.store_name}<br /></span>
                                          )}
                                          {items?.credit_user?.users_name && (
                                            <span>Name: {items?.credit_user?.users_name} {items?.credit_user?.last_name}<br /></span>
                                          )}
                                          {items?.credit_user?.users_email && (
                                            <span>Email: {items?.credit_user?.users_email}<br /></span>
                                          )}
                                          {items?.credit_user?.users_mobile && (
                                            <span>Mobile: {items?.credit_user?.users_mobile}<br /></span>
                                          )}
                                        </>
                                      ) : (<>
                                          {items?.debit_user?.store_name && (
                                            <span>Store: {items?.debit_user?.store_name}<br /></span>
                                          )}
                                          {items?.debit_user?.users_name && (
                                            <span>Name: {items?.debit_user?.users_name} {items?.debit_user?.last_name}<br /></span>
                                          )}
                                          {items?.debit_user?.users_email && (
                                            <span>Email: {items?.debit_user?.users_email}<br /></span>
                                          )}
                                          {items?.debit_user?.users_mobile && (
                                            <span>Mobile: {items?.debit_user?.users_mobile}<br /></span>
                                          )}
                                      </>)}
                                    </td>
                                    <td>{items?.before_amount || '0'}</td>
                                    <td>{items?.other_expanses || '0'}</td>
                                    <td>{parseFloat(items?.amount)  - parseFloat(items?.other_expanses || 0) || '0'}</td>
                                    <td>{items?.after_amount || '0'}</td>
                                    <td>{items?.narration || '-'}</td>
                                    <td>
                                      {items?.record_type === 'Credit' ? (
                                        <button className="btn btn-success">{items?.record_type}</button>
                                      ) : (<button className="btn btn-danger">{items?.record_type}</button>)}
                                    </td>
                                    <td>
                                      {items?.from_user?.store_name && (
                                        <span>Store: {items?.from_user?.store_name}<br /></span>
                                      )}
                                      {items?.from_user?.users_name && (
                                        <span>Name: {items?.from_user?.users_name} {items?.from_user?.last_name}<br /></span>
                                      )}
                                      {/* {items?.from_user?.users_email && (
                                        <span>Email: {items?.from_user?.users_email}<br /></span>
                                      )} */}
                                      {items?.from_user?.users_mobile ? (
                                        <span>Mobile: {items?.from_user?.users_mobile}</span>
                                      ):(<>
                                        <span>{items?.created_by_users_type }<br /></span>
                                        <span>{`${items?.created_by_users_id?.admin_first_name} ${items?.created_by_users_id?.admin_last_name}` }<br /></span>
                                      </>)}
                                    </td>
                                    <td>
                                      {items?.agent_id ? (
                                        <span>
                                          {`${items?.agent_id?.first_name} ${items?.agent_id?.last_name}`}<br /> 
                                          ({items?.agent_id?.phone})
                                        </span>
                                      ):`Self`}
                                    </td>
                                    <td className="admin_user_list_date">{moment(items?.createdAt).format('DD-MM-YYYY HH:mm')}</td>
                                    {(PERMISSION?.reverse === 'Y' || PERMISSION?.fullAccess === 'Y') && (<>
                                      {(items?.is_reverse === 'N')  ? (
                                        <td>
                                          {(items?.created_by_users_type !== 'Admin' || items?.narration === 'Submitted Amount') ? (
                                            <Dropdown
                                              overlay={
                                                <Menu>
                                                  <Menu.Item key={`01`} onClick={() => handleReverseAmount(items?._id) } >
                                                    <FontAwesomeIcon icon={faRecycle} /> <span className="show_span">Reverse</span>
                                                  </Menu.Item>
                                                </Menu>
                                              }
                                              placement="bottomLeft"
                                              arrow
                                            >
                                              <FontAwesomeIcon icon={faEllipsis} /> 
                                            </Dropdown>
                                          ) : (<>--</>)}
                                        </td>
                                      ):(
                                        <td>Reversed</td>
                                      )}
                                    </>)}
                                    
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} user_id={''} filterOption={filter || {}} />
    </>
  );
}
